import { hexToRGB } from './hex-to-rgb';

export function getBoxShadowAsList(rawShadow: any[]): string[] {
	return rawShadow.map(({ radius, offset, color, opacity }) => {
		const { r, g, b } = hexToRGB(color);
		return `${offset.x}px ${offset.y}px ${radius}px rgba(${r}, ${g}, ${b}, ${opacity})`;
	});
}
